import { render, staticRenderFns } from "./DialogPlan.vue?vue&type=template&id=71d124a5&scoped=true&"
import script from "./DialogPlan.vue?vue&type=script&lang=js&"
export * from "./DialogPlan.vue?vue&type=script&lang=js&"
import style0 from "./DialogPlan.vue?vue&type=style&index=0&id=71d124a5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71d124a5",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/diego/Desktop/code/asta-live/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('71d124a5')) {
      api.createRecord('71d124a5', component.options)
    } else {
      api.reload('71d124a5', component.options)
    }
    module.hot.accept("./DialogPlan.vue?vue&type=template&id=71d124a5&scoped=true&", function () {
      api.rerender('71d124a5', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/dialogs/DialogPlan.vue"
export default component.exports